module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClickoutside),
      expression: "handleClickoutside"
    }],
    staticClass: "el-autocomplete"
  }, [_c('el-input', {
    ref: "input",
    attrs: {
      "value": _vm.model[_vm.labelField],
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "size": _vm.size
    },
    on: {
      "change": _vm.handleChange,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    },
    nativeOn: {
      "compositionstart": function($event) {
        return _vm.handleComposition($event)
      },
      "compositionupdate": function($event) {
        return _vm.handleComposition($event)
      },
      "compositionend": function($event) {
        return _vm.handleComposition($event)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        _vm.highlight(_vm.highlightedIndex - 1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        _vm.highlight(_vm.highlightedIndex + 1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleKeyEnter($event)
      }],
      "click": function($event) {
        return _vm.handleIconClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-input__icon icon",
    class: _vm.ishover && _vm.model[_vm.labelField] ? 'el-icon-close' : 'hrfont hr-reference',
    attrs: {
      "slot": "icon"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.refClick(_vm.model[_vm.labelField], _vm.labelField, _vm.field, _vm.resdata)
      },
      "mouseenter": function($event) {
        _vm.ishover = true
      },
      "mouseleave": function($event) {
        _vm.ishover = false
      }
    },
    slot: "icon"
  })]), _vm._v(" "), _c('reference-suggestions', {
    ref: "suggestions",
    class: [_vm.popperClass ? _vm.popperClass : ''],
    attrs: {
      "suggestions": _vm.suggestions
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec4fd55c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/reference.vue
// module id = 1411
// module chunks = 107